import { configureStore } from "@reduxjs/toolkit";
import currencyReducer from "./currencySlice";
import notificationReducer from "./notificationSlice";
import cardChargedSlice from "./cardChargedSlice";
import payloadCurrentPowerSlice from "./payloadCurrentPowerSlice";
import visitReducer from './dashboardVisits';

const store = configureStore({
  reducer: {
    currency: currencyReducer,
    payloadCurrentPower: payloadCurrentPowerSlice,
    notification: notificationReducer,
    cardCharged: cardChargedSlice,
    visit: visitReducer,
  },
});

export default store;
